export const GroupNodeStyles = {
  border: "none",
  background: "none",
};

export const blueEdgeStyles = {
  strokeWidth: 2,
  stroke: "#6E7FFF",
};

export const grayEdgeStyles = {
  strokeWidth: 2,
  stroke: "#CFD9E9",
};

export const GraphLeftNodes = ["Users", "Machines", "Accounts"];

export const Configuration = {
  Root: {
    position: { x: 500, y: 350 },
    type: "rootNode",
    style: { background: "#eef2ff" },
  },
  Account: {
    position: { x: 350, y: 200 },
    style: GroupNodeStyles,
    type: "groupNode",
  },
  Machine: {
    position: { x: 350, y: 200 },
    style: GroupNodeStyles,
    type: "groupNode",
  },
  User: {
    position: { x: 350, y: 640 },
    style: GroupNodeStyles,
    type: "groupNode",
  },
  Owner: {
    position: { x: 800, y: 200 },
    style: GroupNodeStyles,
    type: "groupNode",
  },
  Credential: {
    position: { x: 800, y: 370 },
    style: GroupNodeStyles,
    type: "groupNode",
  },
  Entitlement: {
    position: { x: 800, y: 670 },
    style: GroupNodeStyles,
    type: "groupNode",
  },
  AccountScrollableNode: {
    position: { x: 0, y: 150 },
    type: "scrollableNode",
  },
  MachineScrollableNode: {
    position: { x: 0, y: 150 },
    type: "scrollableNode",
  },
  UserScrollableNode: {
    position: { x: 0, y: 600 },
    type: "scrollableNode",
  },
  OwnerScrollableNode: {
    position: { x: 1000, y: 50 },
    type: "scrollableNode",
  },
  CredentialScrollableNode: {
    position: { x: 1000, y: 350 },
    type: "scrollableNode",
  },
  EntitlementScrollableNode: {
    position: { x: 1000, y: 600 },
    type: "scrollableNode",
  },
};

export const NodesGroups = [
  "account",
  "user",
  "owner",
  "machine",
  "credential",
  "entitlement",
];
